import NavigateTo from 'actions/current_location/navigate_to';
import UserEditor from 'models/location/user_editor';
import UsersAdmin from 'models/location/users_admin';

export default class NavigateToUser {
  constructor(context) {
    this.context = context;
  }

  run({ paginationStartIndex, scrollTop, textFilter, userId }) {
    const currentLocation = this.context.stores.currentLocation.get();
    if (currentLocation instanceof UsersAdmin) {
      currentLocation.setScrollTop(scrollTop);
      currentLocation.setAttributes({ paginationStartIndex, textFilter });
      this.context.stores.currentLocation.set(currentLocation);
    }

    this.context.executeAction(NavigateTo, UserEditor.create({ userId }));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/navigate_to_user.js